import React from 'react';
import { Link } from 'react-router-dom'

const Header = () => (
    <div>
        <Link className="button" to="/expenses/add">Add Expense</Link>
        <Link className="button" to="/category/add">Add Category</Link>
    </div>
);

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js